import { render, staticRenderFns } from "./ChatStatistics.vue?vue&type=template&id=5bbaffc8&scoped=true&"
import script from "./ChatStatistics.vue?vue&type=script&lang=js&"
export * from "./ChatStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ChatStatistics.vue?vue&type=style&index=0&id=5bbaffc8&prod&lang=scss&scoped=true&"
import style1 from "./ChatStatistics.vue?vue&type=style&index=1&id=5bbaffc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbaffc8",
  null
  
)

export default component.exports